namespace RioERP.Masters {
    export interface HsnMasterForm {
        Name: Serenity.StringEditor;
        HsnCode: Serenity.StringEditor;
        TaxCategoryId: Serenity.LookupEditor;
    }

    export class HsnMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.HsnMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HsnMasterForm.init)  {
                HsnMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(HsnMasterForm, [
                    'Name', w0,
                    'HsnCode', w0,
                    'TaxCategoryId', w1
                ]);
            }
        }
    }
}
